import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import { capitalize } from 'lodash';
import DetailField from '../../../../common/outlet/outlet-detail-field';
import DamagedBarcodeSubmissionViewForm from './damaged-barcode-submission-view-form';

class DamagedBarcodeSubmissionViewDetails extends Component {
  render() {
    const { scannerCode: { id, attributes } } = this.props;
    const { status } = attributes;

    return (
      <div className="container-flud">
        <Col md={6}>
          <DetailField data={id} label={'ID'} />
          <DetailField data={attributes['created-at']} label={'Scan date'} />
          <DetailField data={attributes['customer-number']} label={'Customer number'} />
          <Row>
            <Col md={6}>
              Scanning User ID:
            </Col>
            <Col md={6}>
              <Link to={`/admin/users/${attributes['user-id']}/edit`}>
                {attributes['user-id']}
              </Link>
            </Col>
          </Row>
          <DetailField data={attributes.email} label={'Scanning User email'} />
          <DetailField data={attributes.mobile} label={'Scanning User mobile'} />
          <br />
          <DetailField data={capitalize(status)} label={'Status'} />
          {status === 'approved' && (
            <div>
              <DetailField data={attributes['product-code']} label={'Product code'} />
              <DetailField data={attributes['outer-code']} label={'Outer code'} />
            </div>
          )}
          {status === 'declined' && (
            <DetailField data={attributes['override-request-decline-reason']} label={'Decline reason'} />
          )}
          <Row>
            <h3 className="text-uppercase">
              Damaged Barcode Image
            </h3>
          </Row>
          <Row>
            {attributes['image-url'] && (
              <Link target="_blank" to={attributes['image-url']}>
                {attributes['image-name']}
              </Link>
            )}
          </Row>
        </Col>
        {status === 'pending' && (
          <Col md={12} className="mg-top-60">
            <Row>
              <DamagedBarcodeSubmissionViewForm id={id} />
            </Row>
          </Col>
        )}
      </div>
    );
  }
}

export default DamagedBarcodeSubmissionViewDetails;



// WEBPACK FOOTER //
// ./src/components/admin/scans/damaged-barcode-submissions/view/damaged-barcode-submission-view-details.jsx